const getCompStatsByListingAliasQuery = (listingAlias: string) => {
  // validate
  if (!listingAlias) {
    // do not throw new Error otherwise page will not load
    return new Error('listingAlias is required');
  }

  return `
        query getCompStatsByListingAliasQuery {
            byListingAlias(
                listingAlias: "${listingAlias}"
            ) {
                similarFloorplans {
                    stats {
                        startDate
                        endDate
                        views {
                            total
                        }
                        inquiries {
                            total
                        }
                    }
                }
                stats {
                    startDate
                    endDate
                    views {
                        total
                    }
                    inquiries {
                        total
                    }
                }
            }
        }
    `;
};

const getCompsByListingAliasQuery = (listingAlias: string) => {
  // validate
  if (!listingAlias) {
    // do not throw new Error otherwise page will not load
    return new Error('listingAlias is required');
  }

  return `
        query getCompsByListingAliasQuery {
            byListingAlias(
                listingAlias: "${listingAlias}"
            ) {
                geo {
                    lat
                    lon
                }
                floorplans {
                    aliasEncoded
                    address {
                        street
                        city
                        state
                        zip
                        unit
                    }
                }
              similarFloorplans {
                    boundingBox {
                        minLat
                        maxLat
                        minLon
                        maxLon
                    }
                    lowestPriceIncluded
                    highestPriceIncluded
                    floorplans {
                        active
                        aliasEncoded
                        geo {
                            lat
                            lon
                          }
                    }
              }
            }
          }
    `;
};

export { getCompStatsByListingAliasQuery, getCompsByListingAliasQuery };
